(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaDosage', RcopiaDosage);

    RcopiaDosage.$inject = ['$resource'];

    function RcopiaDosage ($resource) {
        var resourceUrl =  'api/rcopia-dosages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
